import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import callrecorderApi from '../../api/callrecorderApi';
import callrecorderUrls from "../../configs/callrecorder/callrecorderUrls";
import { UserNumberSubscriptionInterface } from '../../store/callrecorder/userNumberSubscriptionsSlice';

const PREFIX = 'callrecorder';

const processStrategy = (value: any) => {
  return {
    ...value,
    url: callrecorderUrls.userNumberSubscriptionPath(value.id)
  };
}

export const userNumberSubscriptionsEntity = new schema.Entity(
  'userNumberSubscriptions',
  {},
  {
    processStrategy
  }
);

export const userNumberSubscriptionEntity = new schema.Entity(
  'userNumberSubscription',
  {},
  {
    processStrategy
  }
);

const fetchUserNumberSubscriptionsCollection = async (url: string, params: object = {}) => {
  const response = await callrecorderApi.get(url, { params })
  const normalized = normalize<
    any,
    {
      userNumberSubscriptions: { [key: string]: UserNumberSubscriptionInterface };
    }
  >(response.data.user_number_subscriptions, [userNumberSubscriptionsEntity]);

  return {
    userNumberSubscriptions: normalized.entities?.userNumberSubscriptions || {},
    ids: normalized.result,
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    { userNumberSubscription: UserNumberSubscriptionInterface; }
  >(response.data.user_number_subscription, userNumberSubscriptionEntity);
  return normalized.entities;
}

export const fetchUserNumberSubscriptions = createAsyncThunk(
  `${PREFIX}_userNumberSubscriptions/fetchUserNumberSubscriptions`,
  async (params: object = {}) => fetchUserNumberSubscriptionsCollection('/onesky/user_number_subscriptions', params)
);

export const fetchUserNumberSubscription = createAsyncThunk(
  `${PREFIX}_userNumberSubscriptions/fetchUserNumberSubscription`,
  async (id: number | string) => {
    const response = await callrecorderApi.get(`/onesky/user_number_subscriptions/${id}`);
    return normalizeInstance(response);
  }
);
